import { CheckCircle2, MapPin } from "lucide-react";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

const POINTS = [
  "Empresa constructora con sede en Cunit, Tarragona",
  "Especialistas en obra nueva, reformas y rehabilitación",
  "Combinamos oficio artesanal con técnicas avanzadas",
  "Cobertura en Baix Penedès y provincia de Tarragona",
];

export default function About() {
  return (
    <section id="nosotros" data-testid="about-section" className="relative py-24 lg:py-28 bg-[#F8FAFC]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Image side */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl shadow-slate-900/10">
              <img
                src={ABOUT_IMG}
                alt="Equipo Amlou trabajando en obra"
                className="w-full h-[420px] sm:h-[520px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0B1528]/40 to-transparent" />
            </div>

            {/* Floating stats card */}
            <div className="hidden sm:block absolute -bottom-6 -right-6 bg-white p-5 rounded-2xl shadow-2xl border border-slate-100 max-w-[260px]">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-xl bg-[#F26522] flex items-center justify-center">
                  <MapPin className="w-5 h-5 text-white" />
                </div>
                <div>
                  <div className="font-display font-bold text-[#0B1528]">Cunit, Tarragona</div>
                  <div className="text-xs text-slate-500 font-mono-accent">Baix Penedès</div>
                </div>
              </div>
              <div className="mt-4 pt-4 border-t border-slate-100">
                <p className="text-xs text-slate-600 leading-relaxed">
                  Servicio en toda la provincia y zonas limítrofes.
                </p>
              </div>
            </div>

            {/* Decorative */}
            <div className="hidden lg:block absolute -top-4 -left-4 w-24 h-24 border-2 border-[#F26522] rounded-3xl -z-10" />
          </div>

          {/* Content side */}
          <div>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#F26522]/10 text-[#D95212] text-xs font-mono-accent uppercase tracking-[0.18em] mb-5">
              <span className="w-1.5 h-1.5 rounded-full bg-[#F26522]" />
              Sobre Nosotros
            </div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#0B1528] tracking-tight leading-[1.05]">
              Convertimos planos y proyectos en{" "}
              <span className="text-[#F26522]">obras impecables.</span>
            </h2>
            <p className="mt-5 text-slate-600 text-base sm:text-lg leading-relaxed">
              Somos una empresa constructora especialista en convertir ideas en resultados
              duraderos. Combinamos el oficio artesanal de toda la vida con técnicas avanzadas
              para ofrecer soluciones fiables en cada proyecto.
            </p>

            <ul className="mt-8 space-y-3">
              {POINTS.map((p) => (
                <li key={p} className="flex items-start gap-3">
                  <CheckCircle2 className="w-5 h-5 text-[#F26522] mt-0.5 shrink-0" />
                  <span className="text-slate-700">{p}</span>
                </li>
              ))}
            </ul>

            <div className="mt-9 flex flex-wrap gap-3">
              <a
                data-testid="about-cta-quote"
                href="#contacto"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#0B1528] hover:bg-[#142542] text-white font-semibold text-sm transition-all hover:-translate-y-0.5"
              >
                Solicitar Presupuesto
              </a>
              <a
                data-testid="about-cta-projects"
                href="#proyectos"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-slate-300 text-slate-700 hover:bg-white hover:border-[#F26522] hover:text-[#0B1528] font-semibold text-sm transition-all"
              >
                Ver Nuestros Proyectos
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
